import React, { Component } from "react";

import { Formik, Form } from "formik";
import { CheckboxInput } from "../../../../forms/components";

import { editAdhoc } from "../../../../libs/functions";
import Util from "../../../../libs/util";

import Swal from "sweetalert2";
import { has, map, each, isEmpty } from "lodash";

const editModalName = "edit-adhoc";
const title = "Ad Hoc Payment Types";

class ManageMerchantAdhocPayments extends Component {
	constructor(props) {
		super(props);

		this.state = {
			adhocPaymentMethods: null,
		};
		this.editModalRef = React.createRef();
	}

	componentDidMount = () => {
		this._generateAdhocPaymentMethods();
	};

	componentDidUpdate = (prevProps) => {
		try {
			if (
				JSON.stringify(prevProps?.merchant?.adhocPaymentMethods) !==
					JSON.stringify(this.props?.merchant?.adhocPaymentMethods) ||
				JSON.stringify(prevProps?.baseToAdhocPaymentMethods) !==
					JSON.stringify(this.props?.baseToAdhocPaymentMethods)
			) {
				this._generateAdhocPaymentMethods();
			}
		} catch (err) {
			console.error(err);
		}
	};

	_generateAdhocPaymentMethods = () => {
		// Reset adhocPaymentMethods
		this.setState({ adhocPaymentMethods: null });

		let adhocPaymentMethods = {};
		const { merchant, baseToAdhocPaymentMethods } = this.props;

		// Prepare default adhocPaymentMethods
		each(baseToAdhocPaymentMethods, (adhocs, base) => {
			if (isEmpty(merchant?.paymentGateway[base])) return;

			let temp = {};
			adhocs.forEach((adhoc) => {
				temp[adhoc] = false;
			});
			adhocPaymentMethods[base] = temp;
		});

		if (merchant?.adhocPaymentMethods) {
			each(merchant.adhocPaymentMethods, (adhocs, base) => {
				each(adhocs, (val, key) => {
					if (has(adhocPaymentMethods, [base, key]))
						adhocPaymentMethods[base][key] = val;
				});
			});
		}

		this.setState({ adhocPaymentMethods });
	};

	_editAdhoc = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: `Editing ${title}`,
			allowOutsideClick: () => !Swal.isLoading(),
			onBeforeOpen: async () => {
				await Util.hideModal(editModalName);
			},
			onOpen: async () => {
				try {
					let status = await editAdhoc({
						id: this.props.merchant.id,
						adhocPaymentMethods: values,
					});
					Swal.hideLoading();
					setSubmitting(false);

					if (status) {
						Swal.fire({
							icon: "success",
							title: `${title} Edited`,
						}).then(async () => {
							this.props.retrieveMerchants(true);
							resetForm();
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Edit ${title}`,
						});
					}
				} catch (err) {
					setSubmitting(false);
					if (err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Edit ${title}`,
							onClose: () => {},
						});
					}
				}
			},
		});
	};

	_renderBaseToAdhocPayments = (editable = false) => {
		const { MDRTypes } = this.props;
		const { adhocPaymentMethods } = this.state;

		return map(adhocPaymentMethods, (adhocPaymentTypes, basePaymentType) => {
			return (
				<tr key={basePaymentType}>
					<td className="uk-text-center">
						<img
							className="uk-img"
							src={`data:image/*;base64,${MDRTypes[basePaymentType].image}`}
							width="50"
						/>
					</td>
					<td>
						<div className="uk-flex uk-flex-between uk-flex-left@s uk-flex-wrap">
							{this._renderAdhocPayments({
								adhocPaymentTypes,
								basePaymentType,
								editable,
							})}
						</div>
					</td>
				</tr>
			);
		});
	};

	_renderAdhocPayments = ({
		adhocPaymentTypes,
		basePaymentType,
		editable = false,
	}) => {
		const { MDRTypes } = this.props;

		return map(adhocPaymentTypes, (isEnabled, adhoc) => {
			return (
				<div className={"uk-margin-left"} key={adhoc}>
					<label key={adhoc} className="uk-form-label">
						{editable ? (
							<CheckboxInput
								key={adhoc}
								noMargin={true}
								label={MDRTypes[adhoc]?.label}
								name={`${basePaymentType}.${adhoc}`}
							/>
						) : (
							<>
								<input
									className="uk-checkbox uk-margin-right"
									name={`adhocPaymentMethods.${basePaymentType}.${adhoc}`}
									type="checkbox"
									checked={isEnabled}
									readOnly
								/>
								{MDRTypes[adhoc]?.label}
							</>
						)}
					</label>
				</div>
			);
		});
	};

	_renderEdit = () => {
		const { adhocPaymentMethods } = this.state;
		if (!adhocPaymentMethods) return;

		return (
			<div
				id={editModalName}
				className="uk-modal-container"
				uk-modal="stack: true"
				ref={this.editModalRef}
			>
				<div className="uk-modal-dialog uk-modal-body">
					<h2 className="uk-modal-title">Edit {title}</h2>
					<Formik
						initialValues={adhocPaymentMethods}
						enableReinitialize={true}
						onSubmit={this._editAdhoc}
					>
						<Form className="uk-form-stacked">
							<table className="uk-table uk-table-striped uk-table-middle">
								<thead>
									<tr>
										<th className="uk-text-center">Base</th>
										<th>Ad Hoc</th>
									</tr>
								</thead>
								<tbody>{this._renderBaseToAdhocPayments(true)}</tbody>
							</table>
							<p className="uk-text-right">
								<button
									className="uk-button uk-button-default uk-modal-close"
									type="button"
								>
									Cancel
								</button>
								<button className="uk-button uk-button-primary" type="submit">
									Edit
								</button>
							</p>
						</Form>
					</Formik>
				</div>
			</div>
		);
	};

	render() {
		const { readOnly } = this.props;
		const { adhocPaymentMethods } = this.state;
		if (isEmpty(adhocPaymentMethods)) return <></>;

		return (
			<div className="uk-margin-bottom">
				<h4 className="uk-margin-remove">
					<span className="uk-flex uk-flex-middle">
						<i
							className="uk-margin-small-right form-header-icon"
							uk-icon="icon: fa-solid-link; ratio: 0.9"
						/>
						{title}
						{!readOnly && (
							<button
								className="uk-margin-small-left uk-icon-button uk-button-primary"
								uk-icon="icon: fa-solid-pencil-alt; ratio: 0.5"
								type="button"
								onClick={() => Util.showModal(editModalName)}
							/>
						)}
					</span>
					<hr className="uk-margin-small-top uk-margin-small-bottom" />
				</h4>
				<div className="view-gateway-table uk-padding-small uk-padding-remove-vertical">
					<table className="uk-table uk-table-striped uk-table-middle">
						<thead>
							<tr>
								<th className="uk-text-center">Base</th>
								<th>Ad Hoc</th>
							</tr>
						</thead>
						<tbody>{this._renderBaseToAdhocPayments()}</tbody>
					</table>
				</div>
				{this._renderEdit()}
			</div>
		);
	}
}

export default ManageMerchantAdhocPayments;
